// Payment Statuses
export const PAYMENT_STATUS_REJECTED = 'rejected'
export const PAYMENT_STATUS_ATTEMPTED = 'attempted'
export const PAYMENT_STATUS_PENDING = 'pending'
export const PAYMENT_STATUS_SUCCESS = 'success'
export const PAYMENT_STATUS_FAILED = 'failed'
export const PAYMENT_STATUS_CANCELED = 'canceled'
export const PAYMENT_STATUS_PAID = 'partial'
export const PAYMENT_STATUS_PARTIAL = 'partial'
export const PAYMENT_STATUS_REFUNDED = 'refunded'

export const PAYMENT_STATUS = {
  REJECTED: PAYMENT_STATUS_REJECTED,
  ATTEMPTED: PAYMENT_STATUS_ATTEMPTED,
  PENDING: PAYMENT_STATUS_PENDING,
  SUCCESS: PAYMENT_STATUS_SUCCESS,
  FAILED: PAYMENT_STATUS_FAILED,
  CANCELED: PAYMENT_STATUS_CANCELED,
  PAID: PAYMENT_STATUS_PAID,
  PARTIAL: PAYMENT_STATUS_PARTIAL,
  REFUNDED: PAYMENT_STATUS_REFUNDED,
}

export const PAYMENT_STATUS_OPTIONS = [
  { label: 'Pending', value: PAYMENT_STATUS_PENDING },
  { label: 'Success', value: PAYMENT_STATUS_SUCCESS },
  { label: 'Partial', value: PAYMENT_STATUS_PARTIAL },
  { label: 'Failed', value: PAYMENT_STATUS_FAILED },
  { label: 'Canceled', value: PAYMENT_STATUS_CANCELED },
  { label: 'Rejected', value: PAYMENT_STATUS_REJECTED },
  { label: 'Attempted', value: PAYMENT_STATUS_ATTEMPTED },
  { label: 'Refunded', value: PAYMENT_STATUS_REFUNDED },
]

// Payment Methods
export const PAYMENT_METHOD_COD = 'cash_on_delivery'
export const PAYMENT_METHOD_INSTALLMENT = 'installment'
export const PAYMENT_METHOD_MANUAL = 'manual'
export const PAYMENT_METHOD_ONLINE = 'online'

export const PAYMENT_METHOD = {
  COD: PAYMENT_METHOD_COD,
  INSTALLMENT: PAYMENT_METHOD_INSTALLMENT,
  MANUAL: PAYMENT_METHOD_MANUAL,
  ONLINE: PAYMENT_METHOD_ONLINE,
}

export const PAYMENT_METHOD_OPTIONS = [
  { label: 'Cash On Delivery', value: PAYMENT_METHOD_COD },
  { label: 'Online', value: PAYMENT_METHOD_ONLINE },
  { label: 'Manual', value: PAYMENT_METHOD_MANUAL },
  { label: 'Installment', value: PAYMENT_METHOD_INSTALLMENT },
]

// Payment Options (Gateways/Providers)
export const PAYMENT_OPTION_CASH = 'cash'
export const PAYMENT_OPTION_BKASH = 'bkash'
export const PAYMENT_OPTION_NAGAD = 'nagad'
export const PAYMENT_OPTION_ROCKET = 'rocket'
export const PAYMENT_OPTION_WALLET = 'wallet'
export const PAYMENT_OPTION_SSL_COMMERZ = 'ssl_commerz'
export const PAYMENT_OPTION_STRIPE = 'stripe'

export const PAYMENT_OPTION = {
  CASH: PAYMENT_OPTION_CASH,
  BKASH: PAYMENT_OPTION_BKASH,
  NAGAD: PAYMENT_OPTION_NAGAD,
  ROCKET: PAYMENT_OPTION_ROCKET,
  WALLET: PAYMENT_OPTION_WALLET,
  SSL_COMMERZ: PAYMENT_OPTION_SSL_COMMERZ,
  STRIPE: PAYMENT_OPTION_STRIPE,
}

export const PAYMENT_OPTION_OPTIONS = [
  { label: 'Cash', value: PAYMENT_OPTION_CASH },
  { label: 'bKash', value: PAYMENT_OPTION_BKASH },
  { label: 'Nagad', value: PAYMENT_OPTION_NAGAD },
  { label: 'Rocket', value: PAYMENT_OPTION_ROCKET },
  { label: 'Wallet', value: PAYMENT_OPTION_WALLET },
  { label: 'SSL Commerz', value: PAYMENT_OPTION_SSL_COMMERZ },
  { label: 'Stripe', value: PAYMENT_OPTION_STRIPE },
]

// Payment Types
export const PAYMENT_TYPE_PAYMENT = 'payment'
export const PAYMENT_TYPE_REFUND = 'refund'

export const PAYMENT_TYPE = {
  PAYMENT: PAYMENT_TYPE_PAYMENT,
  REFUND: PAYMENT_TYPE_REFUND,
}

// Order Statuses
export const ORDER_STATUS_PENDING = 'pending'
export const ORDER_STATUS_ACTIVE = 'active'
export const ORDER_STATUS_READY_TO_SHIP = 'ready_to_ship'
export const ORDER_STATUS_DISPATCHED = 'dispatched'
export const ORDER_STATUS_ON_THE_WAY = 'on_the_way'
export const ORDER_STATUS_DELIVERED = 'delivered'
export const ORDER_STATUS_CANCELLED = 'cancelled'
export const ORDER_STATUS_RETURNED = 'returned'
export const ORDER_STATUS_PARTIALLY_RETURNED = 'partially_returned'

export const ORDER_STATUS = {
  PENDING: ORDER_STATUS_PENDING,
  ACTIVE: ORDER_STATUS_ACTIVE,
  READY_TO_SHIP: ORDER_STATUS_READY_TO_SHIP,
  DISPATCHED: ORDER_STATUS_DISPATCHED,
  ON_THE_WAY: ORDER_STATUS_ON_THE_WAY,
  DELIVERED: ORDER_STATUS_DELIVERED,
  CANCELLED: ORDER_STATUS_CANCELLED,
  RETURNED: ORDER_STATUS_RETURNED,
  PARTIALLY_RETURNED: ORDER_STATUS_PARTIALLY_RETURNED,
}

export const ORDER_STATUS_OPTIONS = [
  { label: 'Pending', value: ORDER_STATUS_PENDING },
  { label: 'Active', value: ORDER_STATUS_ACTIVE },
  { label: 'Ready To Ship', value: ORDER_STATUS_READY_TO_SHIP },
  { label: 'Dispatched', value: ORDER_STATUS_DISPATCHED },
  { label: 'On The Way', value: ORDER_STATUS_ON_THE_WAY },
  { label: 'Delivered', value: ORDER_STATUS_DELIVERED },
  { label: 'Cancelled', value: ORDER_STATUS_CANCELLED },
  { label: 'Returned', value: ORDER_STATUS_RETURNED },
  // { label: 'Partially Returned', value: ORDER_STATUS_PARTIALLY_RETURNED },
]

// Order Return Statuses
export const ORDER_RETURN_STATUS_REQUESTED = 'requested'
export const ORDER_RETURN_STATUS_REQUEST_ACCEPTED = 'request_accepted'
export const ORDER_RETURN_STATUS_REQUEST_REJECTED = 'request_rejected'
export const ORDER_RETURN_STATUS_COMPLETED = 'completed'

export const ORDER_RETURN_STATUS = {
  REQUESTED: ORDER_RETURN_STATUS_REQUESTED,
  REQUEST_ACCEPTED: ORDER_RETURN_STATUS_REQUEST_ACCEPTED,
  REQUEST_REJECTED: ORDER_RETURN_STATUS_REQUEST_REJECTED,
  COMPLETED: ORDER_RETURN_STATUS_COMPLETED,
}

// Order Log Action Types
export const ORDER_LOG_ACTION_TYPE_PROCESS = 'process'
export const ORDER_LOG_ACTION_TYPE_EDIT = 'edit'
export const ORDER_LOG_ACTION_TYPE_OTHERS = 'others'

// General Statuses
export const STATUS_ACTIVE = 'active'
export const STATUS_INACTIVE = 'inactive'
export const STATUS_PENDING = 'pending'
export const STATUS_DEACTIVATED = 'deactivated'
export const STATUS_SUSPENDED = 'suspended'
export const STATUS_BANNED = 'banned'
export const STATUS_REJECTED = 'rejected'
export const STATUS_DELETED = 'deleted'
// specific for products
export const STATUS_DRAFT = 'draft'
export const STATUS_ARCHIVED = 'archived'

export const STATUS = {
  ACTIVE: STATUS_ACTIVE,
  INACTIVE: STATUS_INACTIVE,
  PENDING: STATUS_PENDING,
  DEACTIVATED: STATUS_DEACTIVATED,
  SUSPENDED: STATUS_SUSPENDED,
  BANNED: STATUS_BANNED,
  REJECTED: STATUS_REJECTED,
  DELETED: STATUS_DELETED,
  DRAFT: STATUS_DRAFT,
  ARCHIVED: STATUS_ARCHIVED,
}

export const STATUS_OPTIONS = [
  { label: 'Active', value: STATUS_ACTIVE },
  { label: 'Inactive', value: STATUS_INACTIVE },
  { label: 'Pending', value: STATUS_PENDING },
  { label: 'Draft', value: STATUS_DRAFT },
  { label: 'Archived', value: STATUS_ARCHIVED },
  { label: 'Deactivated', value: STATUS_DEACTIVATED },
  { label: 'Suspended', value: STATUS_SUSPENDED },
  { label: 'Banned', value: STATUS_BANNED },
  { label: 'Rejected', value: STATUS_REJECTED },
]

// Discount Types
export const DISCOUNT_TYPE_PERCENTAGE = 'percentage'
export const DISCOUNT_TYPE_CASH = 'cash'
export const DISCOUNT_TYPE_FIXED_AMOUNT = 'fixed_amount'

export const DISCOUNT_TYPE = {
  PERCENTAGE: DISCOUNT_TYPE_PERCENTAGE,
  CASH: DISCOUNT_TYPE_CASH,
  FIXED_AMOUNT: DISCOUNT_TYPE_FIXED_AMOUNT,
}

export const DISCOUNT_TYPE_OPTIONS = [
  { label: 'Percentage', value: DISCOUNT_TYPE_PERCENTAGE },
  { label: 'Cash', value: DISCOUNT_TYPE_CASH },
]

// Legacy Discount Types (Keeping compatibility)
export const PERCENTAGE = DISCOUNT_TYPE_PERCENTAGE
export const CASH = DISCOUNT_TYPE_CASH

// Credential Types
export const CREDENTIAL_TYPE_SANDBOX = 'sandbox'
export const CREDENTIAL_TYPE_PRODUCTION = 'production'

export const CREDENTIAL_TYPE = {
  SANDBOX: CREDENTIAL_TYPE_SANDBOX,
  PRODUCTION: CREDENTIAL_TYPE_PRODUCTION,
}

// Delivery Methods
export const DELIVERY_METHOD_TYPE_PICKUP = 'pickup'
export const DELIVERY_METHOD_TYPE_RIDER = 'rider'
export const DELIVERY_METHOD_TYPE_COURIER = 'courier'

export const DELIVERY_METHOD_TYPE = {
  PICKUP: DELIVERY_METHOD_TYPE_PICKUP,
  RIDER: DELIVERY_METHOD_TYPE_RIDER,
  COURIER: DELIVERY_METHOD_TYPE_COURIER,
}

export const DELIVERY_METHOD_TYPE_OPTIONS = [
  { label: 'Pickup', value: DELIVERY_METHOD_TYPE_PICKUP },
  { label: 'Rider', value: DELIVERY_METHOD_TYPE_RIDER },
  { label: 'Courier', value: DELIVERY_METHOD_TYPE_COURIER },
]

// Specific Statues

export const PRODUCT_STATUS = {
  active: STATUS_ACTIVE,
  inactive: STATUS_INACTIVE,
}

export const PRODUCT_STATUS_OPTIONS = [
  { label: 'Active', value: PRODUCT_STATUS.active },
  { label: 'Inactive', value: PRODUCT_STATUS.inactive },
]
